// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__s-u52","form":"styles_form__jZ31T","submit":"styles_submit__EF0id"};